import { render, staticRenderFns } from "./MarketCollectionHero.vue?vue&type=template&id=66e15df9&scoped=true&"
import script from "./MarketCollectionHero.vue?vue&type=script&lang=js&"
export * from "./MarketCollectionHero.vue?vue&type=script&lang=js&"
import style0 from "./MarketCollectionHero.vue?vue&type=style&index=0&id=66e15df9&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e15df9",
  null
  
)

export default component.exports